var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Inertia } from '@inertiajs/inertia';
import swal from 'sweetalert';
import { useForm } from '@inertiajs/inertia-vue3';
const defaultTime = 30 * 1000;
let cancelToken = null;
let timeoutId = null;
let limitTime = 30 * 1000;
let sessionTimeoutId = null;
setSessionTimeoutEvent();
// 成功
Inertia.on('start', (event) => {
    timeoutId = setTimeoutEvent(cancelToken, limitTime);
    //clear timeout for session
    if (sessionTimeoutId) {
        clearTimeout(sessionTimeoutId);
        sessionTimeoutId = null;
    }
    setSessionTimeoutEvent();
});
// 成功
Inertia.on('success', (event) => {
    var _a, _b, _c, _d;
    const status = (_d = (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.errorStatusCode) !== null && _d !== void 0 ? _d : 0;
    checkStatusCode(status);
});
// 例外イベント
const removeExceptionEvent = Inertia.on('exception', (event) => {
    // イベントのキャンセル（Exceptionがスローされないようにする）
    event.preventDefault();
});
// Inertiaフォーム以外をレスポンスで返ってくる場合
Inertia.on('invalid', (event) => {
    event.preventDefault();
});
Inertia.on('finish', () => {
    if (timeoutId) {
        clearTimeout(timeoutId);
    }
    cancelToken = null;
    timeoutId = null;
});
// ステータスコードのチェック
function checkStatusCode(statusCode) {
    const code = statusCode / 100;
    if (code === 5 || code === 4) {
    }
}
// タイムアウトのイベント
function setTimeoutEvent(cancelToken, time) {
    const limit = time !== null && time !== void 0 ? time : defaultTime;
    const id = setTimeout(() => {
        if (cancelToken) {
            cancelToken === null || cancelToken === void 0 ? void 0 : cancelToken.cancel();
        }
    }, limit);
    return id;
}
function fetchRole() {
    return __awaiter(this, void 0, void 0, function* () {
        var role = 0;
        const response = yield window.axios.get(route('get_role'));
        role = response.data.role;
        return role;
    });
}
// start timer for session expire
function setSessionTimeoutEvent() {
    // const confirm = new pexxalert($, window, 'confirm', { anchor: 'body' });
    let timeout = window.session_lifetime * 60 * 1000;
    sessionTimeoutId = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
        let currentPath = window.location.pathname;
        let role = yield fetchRole();
        if (role) {
            if (!currentPath.includes('/login')) {
                window.axios.get(route('logout'));
                swal({
                    title: "確認",
                    text: "タイムアウトしました。ログインページに戻ります",
                    icon: "warning",
                    buttons: {
                        ok: {
                            text: "OK",
                            className: "timeout-ok-btn",
                        },
                    },
                })
                    .then(() => {
                    try {
                        if (role == 1) {
                            location.href = route('admin.login');
                        }
                        else if (role == 2) {
                            location.href = route('login.create');
                        }
                    }
                    catch (e) {
                        location.href = route('login.create');
                    }
                });
            }
        }
    }), timeout - 2000);
}
export default class InertiaUtil {
    static getForm(form, key) {
        if (key) {
            return useForm(key, form);
        }
        return useForm(form);
    }
    static post(form, url, callback, options, timeout = defaultTime) {
        limitTime = timeout;
        // 二重送信対策　Processing true： 処理中のためリターンさせる
        if (form.processing)
            return;
        form.transform((data) => (Object.assign(Object.assign({}, data), { _method: 'POST' })));
        form.post(url, Object.assign(Object.assign({}, options), { onCancelToken: (token) => {
                cancelToken = token;
            }, onFinish: (response) => {
                if (callback) {
                    callback(response);
                }
            } }));
    }
    static put(form, url, callback, options, timeout = defaultTime) {
        limitTime = timeout;
        // 二重送信対策　Processing true： 処理中のためリターンさせる
        if (form.processing)
            return;
        // form.transform((data: any) => ({
        //     ...data,
        //     _method: 'PUT',
        // }));
        form.put(url, Object.assign(Object.assign({}, options), { onCancelToken: (token) => {
                cancelToken = token;
            }, onFinish: () => {
                if (callback) {
                    callback();
                }
            } }));
    }
    static delete(form, url, callback, options, timeout = defaultTime) {
        limitTime = timeout;
        // 二重送信対策　Processing true： 処理中のためリターンさせる
        if (form.processing)
            return;
        // form.transform((data: any) => ({
        //     ...data,
        //     _method: 'DELETE',
        // }));
        form.delete(url, Object.assign(Object.assign({}, options), { onCancelToken: (token) => {
                cancelToken = token;
            }, onFinish: () => {
                if (callback) {
                    callback();
                }
            } }));
    }
    static get(url, callback, options, timeout = defaultTime) {
        limitTime = timeout;
        Inertia.get(url, undefined, Object.assign(Object.assign({}, options), { onCancelToken: (token) => {
                cancelToken = token;
            }, onFinish: response => {
                if (callback) {
                    callback(response);
                }
            } }));
    }
    static reload(callback, options, timeout = defaultTime) {
        limitTime = timeout;
        Inertia.reload(Object.assign(Object.assign({}, options), { onCancelToken: (token) => {
                cancelToken = token;
            }, onFinish: () => {
                if (callback) {
                    callback();
                }
            } }));
    }
    static destoractor() {
        // イベントの開放
        removeExceptionEvent();
    }
}
